import { render, staticRenderFns } from "./ModalChangeExpiration.vue?vue&type=template&id=3dcf35be"
import script from "./ModalChangeExpiration.vue?vue&type=script&lang=js"
export * from "./ModalChangeExpiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports